import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { getPagesVersionsByType } from "../../Redux/Actions/pagesActions";
import { ToFirstCapital } from "../../Utils/helpers";
import SearchBar from "../../Components/Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import "./viewPages.css";

const ViewPage = () => {
    const { type } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPagesVersionsByType(type));
    }, [dispatch, type]);


    const pagesState = useSelector((state) => state.pages || {});
    const versionsData = useMemo(() => pagesState.versions?.data || {}, [pagesState.versions?.data]);
    const versionsList = useMemo(() => versionsData.versions || [], [versionsData.versions]);

    const [selectedVersion, setSelectedVersion] = useState("");
    const [displayedPage, setDisplayedPage] = useState({});

    useEffect(() => {
        const current = versionsData.current || {};
        setDisplayedPage(current);
        setSelectedVersion(current.curr_version || "");
    }, [versionsData.current]);

    useEffect(() => {
        if (selectedVersion && versionsList.length > 0) {
            const versionData = versionsList.find(v => v.pages_version === selectedVersion);
            setDisplayedPage(versionData || versionsData.current || {});
        }
    }, [selectedVersion, versionsData, versionsList]);


    return (
        <div className="view-voucher-container">
            <div className="view-voucher-grid padding-20 gap-10 grid-container">
                <div style={{ gridColumn: "3/8" }}>
                    <SearchBar style={{ width: "max-content", background: "#DFE4E7" }} />
                </div>

                <div className="view-voucher-header back-icon margin-0 gap-10 align-center flex-container">
                    <Link to="/pages">
                        <BackIcon style={{ cursor: "pointer" }} />
                    </Link>
                    <div className="view-voucher-title-section referral-view">
                        <h3 className="view-voucher-main-title">Page Details</h3>
                        <h4 className="view-voucher-breadcrumb">Pages / List / View</h4>
                    </div>
                </div>

                <div className="view-voucher-content overall-container">
                    <div className="voucher-hero-card">
                        <div className="voucher-info-item full-width" style={{display: "flex", justifyContent: "space-between"}}>

                            <div className="voucher-info-item voucher-code-item">
                                <span className="voucher-info-label">Type</span>
                                <h2 className="voucher-info-value voucher-code-value" style={{marginTop: "4px", whiteSpace: "nowrap"}}>
                                    {displayedPage.type
                                        ? displayedPage.type
                                            .split("_")
                                            .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
                                            .join(" ")
                                        : "No Data"}
                                </h2>
                            </div>
                            <div>

                                <span className="voucher-info-label" style={{marginBottom: "8px"}}>Version</span>
                                <select
                                    value={selectedVersion}
                                    onChange={(e) => setSelectedVersion(e.target.value)}
                                    className="version-dropdown"
                                    style={{
                                        padding: "8px 12px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        fontSize: "16px",
                                        minWidth: "120px"
                                    }}
                                >
                                    <option value="">Select Version</option>
                                    {versionsList.map((version) => (
                                        <option key={version.pages_version} value={version.pages_version}>
                                            v{version.pages_version}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>


                        <div className="voucher-info-item">
                            <span className="voucher-info-label">Page Name</span>
                            <h2 className="voucher-info-value">
                                {displayedPage.pageName || "No Data"}
                            </h2>
                        </div>

                        <div className="voucher-info-item">
                            <span className="voucher-info-label">Current Version</span>
                            <h2 className="voucher-info-value">
                                {displayedPage.curr_version || displayedPage.pages_version || "No Data"}
                            </h2>
                        </div>

                        <div className="voucher-info-item">
                            <span className="voucher-info-label">Status</span>
                            <h2 className="voucher-info-value">
                                {displayedPage.status ? ToFirstCapital(displayedPage.status) : "No Data"}
                            </h2>
                        </div>

                        <div className="voucher-info-item">
                            <span className="voucher-info-label">Created At</span>
                            <h2 className="voucher-info-value">
                                {displayedPage.created_at || displayedPage.updated_at
                                    ? new Date(displayedPage.created_at || displayedPage.updated_at).toLocaleDateString()
                                    : "No Data"}
                            </h2>
                        </div>

                        <div className="voucher-info-item full-width voucher-brochure-item">
                            <span className="voucher-info-label">PDF</span>
                            {displayedPage.pdf_url ? (
                                <a
                                    href={displayedPage.pdf_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="voucher-brochure-link"
                                >
                                    <svg className="voucher-brochure-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                            d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                    <span>View PDF</span>
                                    <svg className="voucher-external-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                    </svg>
                                </a>
                            ) : (
                                <span className="voucher-info-value voucher-no-data-text">
                                    No PDF Available
                                </span>
                            )}
                        </div>

                        <div className="voucher-info-item full-width">
                            <span className="voucher-info-label">Short Description</span>
                            <h4 className="voucher-info-value voucher-description">
                                {displayedPage.description || "No Data"}
                            </h4>
                        </div>
                    </div>

                    <div className="voucher-details-section">
                        <h4 className="voucher-section-title">Content</h4>
                        <div className="voucher-info-value voucher-description" style={{ color: "black" }}>
                            {displayedPage.content || "No Data"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewPage;
